import { useMQTT } from 'mqtt-vue-hook'
import { ref } from 'vue';

const mqttHook = useMQTT()
const mqttSubscribed = ref(false);
const mqttConnected = ref(false);
const currentTopics = ref([]);
const mqttClientId = `${process.env.VUE_APP_MQTT_CLIENT_ID}_${Math.random().toString(16).substring(2, 10)}`;

mqttHook.registerEvent("on-connect", (topic, message) => {
  console.info("mqtt event: on-connect");
  mqttConnected.value = true;
});
mqttHook.registerEvent("on-disconnect", async (topic, message) => {
  console.error("mqtt event: on-disconnect");
  // console.log("topic: " + topic, ", message: " + message);
  // await mqttHook.clearEvent()
  mqttConnected.value = false;
},);
mqttHook.registerEvent("on-reconnect", (topic, message) => {
  console.warn("mqtt event: on-reconnect");
  // console.log("topic: " + topic, ", message: " + message);
  mqttConnected.value = true;
});
mqttHook.registerEvent("on-connect-fail", (topic, message) => {
  console.error("mqtt event: on-connect-fail");
  // console.log("topic: " + topic, ", message: " + message);
  mqttConnected.value = false;
});

export default {

  install(Vue) {
     
    Vue.config.globalProperties.mqtt = {
      connect: async () => {
        await mqttHook.connect(process.env.VUE_APP_MQTT_DOMAIN, {
          clean: false,
          keepalive: 60,
          clientId: mqttClientId,
          connectTimeout: 4000,
        })
      },
     reconnect: () => {
        return mqttHook.reconnect(process.env.VUE_APP_MQTT_DOMAIN, {
          clean: false,
          keepalive: 60,
          clientId: mqttClientId,
          connectTimeout: 4000,
        })
      },

      disconnect: () => {
        mqttHook.disconnect();
      },

      subscribe : async(topics) => {
        return new Promise(async (resolve, reject) => {
          try {
            mqttSubscribed.value = false;            
            console.log(topics)
            await mqttHook.subscribe(topics, 0, undefined, () => {
              currentTopics.value = topics;
              mqttSubscribed.value = true;
            });
            currentTopics.value = topics;

            resolve("");
          } catch(e) {
            reject(e);
          }
        })
      },

      unSubscribe : async(topic) => {
        return new Promise(async (resolve, reject) => {
          try {
            await mqttHook.unSubscribe(topic, undefined, (error, packet) => {
              console.log('mqtt unsubscribe callback. topic:' + topic)
              currentTopics.value = [];
              mqttSubscribed.value = false;
            });
            resolve("");
          } catch(e) {
            reject(e);
          }
        })
      },      

      publish : (topic,payload) =>{
        // console.log('mqtt.js => publish : topic : ','$'+topic,',payload:',payload);
        mqttHook.publish('$' + topic, JSON.stringify(payload), 0, undefined, () => {
          // console.log('published!', topic, payload);
        });
      },

      publishAuth : (topic,payload) =>{
        // console.log('mqtt.js => publish : topic : ','$'+topic,',payload:',payload);
        mqttHook.publish(topic, payload, 0, undefined, () => {
          // console.log('published!', topic, payload);
        });
      },

      isSubscribed: () => {
        return currentTopics.value.length === 0 ? true : mqttSubscribed.value;
      },

      isConnected: () => {
        return mqttConnected.value;
      },

      getMqttHook: () => {
        return mqttHook;
      }
    }
  }
}